<template>
  <v-container>
    <div class="headline-container">
      <v-col>
        <v-row justify="space-between">
          <span class="headline">Manajemen Pegawai</span>
          <v-btn color="blue" dark @click="showCreateForm">
            <v-icon left>mdi-account-plus</v-icon> Registrasi Pegawai Baru
          </v-btn>
        </v-row>
      </v-col>
    </div>
    <v-card class="pa-4 mb-3" elevation="3">
      <v-card-title>
        <v-row>
          <v-spacer></v-spacer>
          <v-col lg="4" md="6" cols="12">
            <v-text-field
              v-model="filter.q"
              label="Cari NIP, Nama atau Jabatan"
              single-line
              append-icon="mdi-magnify"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="users"
        hide-default-footer
      >
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="showEditForm(item)" v-bind="attrs" v-on="on">
                <v-icon>mdi-account-edit</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="promtUserAction(item.id, 'reset')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-lock-open</v-icon>
              </v-btn>
            </template>
            <span>Reset Password / PIN</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="promtUserAction(item.id, 'off')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-account-remove-outline</v-icon>
              </v-btn>
            </template>
            <span>Nonaktifkan</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-pagination
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="7"
      ></v-pagination>
      <v-dialog v-model="showDialog" persistent max-width="600px">
        <ValidationObserver ref="observer">
          <v-form @submit.native.prevent="submitForm">
            <v-card>
              <v-card-title>
                <span class="headline">
                  {{ Boolean(model.id) ? 'Update' : 'Input' }} Data Pegawai
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <ValidationProvider
                        name="nip"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          label="NIP"
                          prepend-icon="mdi-account-card-details"
                          v-model="model.nip"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <ValidationProvider
                        name="name"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          label="Nama"
                          prepend-icon="mdi-account"
                          v-model="model.name"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12">
                      <ValidationProvider
                        name="jabatan_id"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-autocomplete
                          label="Jabatan"
                          v-model="model.jabatan_id"
                          :error-messages="errors"
                          prepend-icon="mdi-account-circle"
                          :items="jabatan"
                          item-text="name"
                          item-value="id"
                        ></v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <ValidationProvider
                        name="username"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          label="Username"
                          prepend-icon="mdi-account-badge-horizontal"
                          v-model="model.username"
                          :error-messages="errors"
                          hint="digunakan untuk login"
                          persistent-hint
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="grey"
                  text
                  @click="closeForm"
                  :disabled="submiting"
                  >Batal</v-btn
                >
                <v-btn
                  color="green darken-1"
                  text
                  type="submit"
                  :loading="submiting"
                  >Simpan</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-form>
        </ValidationObserver>
      </v-dialog>
      <v-dialog v-model="showUserPrompDialog" max-width="350px">
        <v-card :loading="submiting" v-if="actionType == 'off'">
          <v-card-title>
            Nonaktifkan Pengguna?
          </v-card-title>
          <v-card-text>
            <v-alert text color="warning">
              Akun akan dinonaktifkan dan jabatan akan dikosongkan
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="submitUserAction">
              Ya
            </v-btn>
            <v-btn
              color="grey"
              text
              @click="showUserPrompDialog = false"
              :disabled="submiting"
            >
              Tidak
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else :loading="submiting">
          <v-card-title>Reset Password / PIN</v-card-title>
          <v-card-text>
            <v-switch
              v-model="reset.password"
              color="warning"
              label="Reset Password dan PIN"
              hint="Password akan direset ke password standar <b>garutkab</b>"
              :persistent-hint="reset.password"
            ></v-switch>
            <v-switch
              v-model="reset.pin"
              color="warning"
              label="Reset PIN"
              :disabled="reset.password"
            ></v-switch>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="submitUserAction">
              Ok
            </v-btn>
            <v-btn
              color="grey"
              text
              @click="showUserPrompDialog = false"
              :disabled="submiting"
            >
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import fetch from '@/services/fetch'
import { users, jabatan } from '@/config/api'
import { debounce } from 'lodash'

const model = {
  id: null,
  name: '',
  username: '',
  nip: '',
  email: '',
  password: '',
  password_confirmation: '',
  jabatan_id: null
}

const initialReset = {
  password: false,
  pin: false
}

export default {
  mounted() {
    this.fetchJabatan()
    this.fetchUsers()
  },
  computed: {
    currentPage() {
      return this.pagination.current_page
    }
  },
  data() {
    return {
      loading: true,
      showDialog: false,
      showUserPrompDialog: false,
      actionType: 'off',
      submiting: false,
      filter: {
        q: ''
      },
      headers: [
        { text: 'NIP', sortable: false, value: 'nip' },
        { text: 'NAMA', sortable: false, value: 'name' },
        { text: 'JABATAN', sortable: false, value: 'nama_jabatan' },
        {
          text: 'USERNAME',
          sortable: false,
          value: 'username',
          filterable: false
        },
        {
          text: '',
          sortable: false,
          value: 'action',
          align: 'right',
          filterable: false
        }
      ],
      users: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 0,
        from: 1
      },
      model,
      jabatan: [],
      reset: { ...initialReset }
    }
  },
  watch: {
    currentPage: function(val) {
      this.fetchUsers(val)
    },
    filter: {
      handler: debounce(function() {
        this.fetchUsers(1)
      }, 500),
      deep: true
    },
    'model.nip': function(val) {
      if (!this.model.id) {
        this.model.username = val
      }
    },
    'reset.password': function(val) {
      if (val) {
        this.reset.pin = true
      }
    },
    showUserPrompDialog: function() {
      this.reset = { ...initialReset }
    }
  },
  methods: {
    fetchJabatan() {
      fetch
        .get(jabatan)
        .then(res => {
          this.jabatan = res.data
        })
        .catch(() => {
          // console.log('Fetch Jabatan Error', err)
        })
    },
    async fetchUsers(page = 1) {
      try {
        this.loading = true
        const params = {
          ...this.filter,
          page
        }
        const res = await fetch.get(users, { params })
        const { data, ...pagination } = res.data
        this.users = data
        this.pagination = pagination
      } catch (error) {
        // console.log('Fetch Data Error', error)
      } finally {
        this.loading = false
      }
    },
    showCreateForm() {
      this.model = { ...model }
      this.showDialog = true
    },
    showEditForm(item) {
      this.showDialog = true
      this.model = { ...item }
    },
    closeForm() {
      this.showDialog = false
      this.$refs.observer.reset()
    },
    async submitForm() {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return true
      }
      try {
        this.submiting = true
        let user
        if (this.model.id) {
          let body = {
            name: this.model.name,
            nip: this.model.nip,
            jabatan_id: this.model.jabatan_id,
            username: this.model.username
          }
          user = await fetch.put(users + '/' + this.model.id, body)
        } else {
          user = await fetch.post(users, this.model)
        }
        this.submiting = false
        this.closeForm()
        this.fetchUsers()
        this.emitSnackBar(user.data.message, 'success')
      } catch (err) {
        this.submiting = false
        if (err.status === 422) {
          this.$refs.observer.setErrors(err.data)
        }
      }
    },
    promtUserAction(id, type = 'off') {
      this.actionUserId = id
      this.actionType = type
      this.showUserPrompDialog = true
    },
    async submitUserAction() {
      try {
        this.submiting = true
        let message = 'Berhasil'
        if (this.actionType == 'off') {
          const { data } = await fetch.delete(users + '/' + this.actionUserId)
          message = data.message
        } else {
          const { data } = await fetch.post(
            'user/' + this.actionUserId + '/reset-password',
            this.reset
          )
          message = data.message
        }
        this.fetchUsers()
        this.emitSnackBar(message, 'success')
      } catch (error) {
        this.emitSnackBar('Terjadi Kesalahan', 'error')
      } finally {
        this.submiting = false
        this.showUserPrompDialog = false
      }
    },
    emitSnackBar(text, color) {
      this.$emit('handle-snackbar', text, color)
    }
  }
}
</script>
